import { connectRouter, RouterState } from "connected-react-router";
import { combineReducers } from "redux";
import environmentReducer, { EnvironmentState } from "./environment";
import { invoiceReducer, IInvoicePageState } from '../../../Routes/Invoices/store/invoices';
import { errorReducer, ErrorState } from './error';
import { History } from 'history'

export interface RootState {
    readonly invoices: IInvoicePageState;
    readonly environment: EnvironmentState;
    readonly router: RouterState;
    readonly errorHandler: ErrorState;
}

export default (history: History<any>) =>  combineReducers<RootState>({
    invoices: invoiceReducer,
    environment: environmentReducer,
    router: connectRouter(history),
    errorHandler: errorReducer
});
